import { type Theme } from "@mui/material/styles";

import { type Consequence } from "./ConsequencePill";

export function getConsequenceDisplay(consequence: Consequence) {
  const isRestricted = consequence === "On Restriction";
  const isNoConsequence = typeof consequence === "number" && consequence === 0;
  const isNegativeConsequence =
    consequence === "Instant restriction" ||
    consequence === "Restriction" ||
    (typeof consequence === "number" && consequence < 0);

  let label = `+ ${consequence} pts`;

  if (typeof consequence === "string") {
    label = consequence;
  } else if (consequence < 0) {
    label = `- ${Math.abs(consequence)} pts`;
  }

  const color = (theme: Theme): string | undefined => {
    if (isRestricted || isNoConsequence) {
      return theme.palette.common.black;
    }

    return isNegativeConsequence
      ? theme.palette.intent?.error.text
      : theme.palette.intent?.success.text;
  };

  return { label, color, isRestricted, isNoConsequence, isNegativeConsequence };
}
